import PropTypes from 'prop-types';
import { memoize } from 'underscore';
// @ts-expect-error not typed
import CalypsoHandleButtonWrapper from 'layout-dnd-components/DndToolbar/CalypsoHandleButtonWrapper';
import PinnedToolbar from 'layout-dnd-components/DndToolbar/PinnedToolbar';
import { buildStyleRowAction, buildDuplicateRowAction, buildDeleteRowAction } from './BaseResponsiveRowToolbar';
import { hashFunctionForNArgs } from './helpers';
import { buildStyleColumnAction, buildDuplicateColumnAction, buildDeleteColumnAction } from './BaseResponsiveColumnToolbar';
import { jsx as _jsx } from "react/jsx-runtime";
const wrapWithCalypsoHandle = connectDragSource => ({
  handleButton
}) => {
  // Wrap styled component with connectDragSource if available
  const ref = connectDragSource ? divElement => connectDragSource(divElement) : undefined;
  return /*#__PURE__*/_jsx(CalypsoHandleButtonWrapper, {
    ref: ref,
    children: handleButton
  });
};
export const buildActionsForEmptyColumn = memoize((columnName, layoutSectionId, dispatch, bus) => {
  return [Object.assign({}, buildStyleColumnAction(columnName, layoutSectionId, dispatch, bus), {
    icon: 'edit'
  }), Object.assign({}, buildDuplicateColumnAction(columnName, layoutSectionId, dispatch, bus), {
    icon: 'duplicate'
  }), Object.assign({}, buildDeleteColumnAction(columnName, layoutSectionId, dispatch, bus), {
    icon: 'delete'
  })];
}, hashFunctionForNArgs(2));
export const buildActionsForEmptyRow = memoize((rowName, layoutSectionId, dispatch, bus) => {
  return [Object.assign({}, buildStyleRowAction(rowName, layoutSectionId, dispatch, bus), {
    icon: 'edit'
  }), Object.assign({}, buildDuplicateRowAction(rowName, layoutSectionId, dispatch, bus), {
    icon: 'duplicate'
  }), Object.assign({}, buildDeleteRowAction(rowName, layoutSectionId, dispatch, bus), {
    icon: 'delete'
  })];
}, hashFunctionForNArgs(2));
export const BaseResponsiveEmptyContainerToolbar = ({
  icon,
  style,
  actions,
  handleTooltip,
  responsiveSize,
  onDropdownOpenChange,
  connectDragSource
}) => {
  return /*#__PURE__*/_jsx(PinnedToolbar, {
    active: true,
    pinLocation: "top right",
    icon: icon,
    actions: actions,
    renderWrappedHandle: wrapWithCalypsoHandle(connectDragSource),
    onDropdownOpenChange: onDropdownOpenChange,
    className: "hs-ls-responsive-toolbar hs-ls-responsive-empty-toolbar",
    style: style,
    responsiveSize: responsiveSize,
    handleTooltip: handleTooltip
  });
};
BaseResponsiveEmptyContainerToolbar.propTypes = {
  icon: PropTypes.node.isRequired,
  style: PropTypes.object,
  actions: PropTypes.array.isRequired,
  responsiveSize: PropTypes.string.isRequired,
  handleTooltip: PropTypes.string,
  onDropdownOpenChange: PropTypes.func,
  connectDragSource: PropTypes.func
};